function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  d: "M90.817 296.211l-23.81-20.059 8.21-31.059 26.273-28.47-19.705-38.393 23.262-48.314 41.324-35.804 24.63-22.431 51.45 21.353 27.367 32.569 45.156.431 14.504 40.333-14.231 35.589s27.367 27.608 27.367 31.059c0 3.451-.274 42.706-.274 42.706l-25.177 20.059-54.734 19.411-58.018-17.902-38.861 12.726-44.334 3.02-10.4-16.824z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  d: "M213.138 249.991l13.141 5.138 11.504 2.558L268.08 145.14l5.546.925 1.48-3.953 30.114 7.427 4.329-6.26-30.33-13.609-14.661-8.4 6.959-41.885 5.254-4.427-7.883-8.918-13.236 6.72 1.736 7.599-9.012 37.972-40.296 3.073-2.196 11.912 24.05.902.179 5.779 6.514 4.292-23.489 105.702z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M227.839 291.348l15.961 9.132 16.392.397 11.863-10.919 1.295-98.67-7.765-10.522-7.981-6.552.44-23.781-10.577-3.418-6.256 2.581.648 27.596-10.785 9.133-2.804 23.228-.431 81.795z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.248 151.908l-4.924-1.193-3.889 2.148 5.444 1.431 3.369-2.386z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M179.888 198.738l-29.198 9.832-32.58 22.45-8.19 25.236-9.08 24.417 4.985 18.518 17.091 14.748 38.456 11.799 29.198-6.555 36.497-9.832 12.997-20.32-7.834-36.052-23.322-31.463-5.341-20.976-14.421-3.933-9.258 2.131z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.559 190.634l-14.594 4.55-.935 5.319 9.12 3.712 13.175-.133 10.888-1.984-1.452-5.872-9.08-4.128-7.122-1.464z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.799 185.226l-14.594 4.55-.936 5.319 9.12 3.712 13.175-.133 8.839-3.308.597-4.548-9.08-4.127-7.121-1.465z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.86 179.708l-18.141 6.535-1.403 5.686-6.799 5.534-1.127 5.249-4.668 4.977 8.466 4.622 9.745.619 4.713 2.447 7.522-4.518 9.298-.393-.841-17.311 10.889-1.984-1.453-5.871-9.08-4.128-7.121-1.464zM140.197 234.603l-21.398-59.679-9.253-7.034.652-4.264-2.283-3.989-1.63-5.502-1.304-6.465 7.662.551 4.076-7.428 3.913 8.115-.206 7.352 4.282 2.414-.652 6.19-1.336 8.562 21.716 59.939-4.239 1.238z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.593 206.368l6.853 1.034 7.409-2.435 1.19 3.549 6.877-3.015 3.657 1.095",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.265 254.869l7.298-14.839M144.845 132.453l13.884-7.588M166.206 146.785l13.172 5.059M279.995 173.3l8.866-8.946M297.728 231.728l6.168 9.129M144.875 178.413l4.626-9.129M118.087 168.836l-6.422-14.489M187.244 244.788l9.279-8.562M181.626 266.643l11.439 1.983M207.722 255.561l4.242 6.477M154.255 223.312l.019 5.481M150.234 270.279l-4.141 3.005M245.698 191.612l-3.347 10.266"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.146 230.977L99.602 279.64l4.67 19.778.275 7.546 12.637 13.142 46.153 14.182 31.469-3.55 16.243 5.461 14.365-3.361 5.629-4.358 3.447-8.765 9.547 3.325 15.412-1.038 11.088-3.893-.104-5.602 3.821-1.478 3.409 2.554 9.66.471 5.682-4.171.142-3.792 3.936-1.587 3.379-2.315-.323-37.032-6.932-2.68-4.832-1.805-.755-5.833-7.569-2.01-7.292 1.844-.271-32.993-13.282 11.297-22.091 5.392-8.538-8.986.364 18.462 1.669 10.294-10.842 25.676-22.769 9.885-32.255 5.392-26.563-15.662-17.348-25.676-2.687-26.777z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.324 212.639l4.93 7.58 2.883 7.533 9.246-6.027 9.444 2.26 3.678-9.04 9.046-2.636-2.286-9.606 2.9-1.198-.749-4.629-7.308 2.502.661 11.26-10.316.823-7.456 4.238-6.76-2.449-7.913-.611zM140.411 234.946l7.436 8.848-.58 6.899 3.543 1.184.629 3.195 2.206 3.696 3.972-4.989 8.462-1.35-4.231-5.562-4.283-1.96-.577-3.288-5.487-.574-6.922-7.428-4.168 1.329z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.495 299.808l-5.309 1.906-.805 3.307 5.051 5.398 11.89 2.577 6.072-6.524-2.548-5.435-3.817.169-3.368 1.622-7.166-3.02zM285.54 256.264l-5.39-1.011-6.901 1.653-3.591 2.243 9.92 3.307 5.185-2.517.777-3.675zM297.579 266.579l-8.494-1.993-6.198 1.889 5.461 3.961 7.201-.702 2.03-3.155z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.868 299.59l3.096-8.953 6.652-3.813-.09 6.856-3.768 5.197-3.22.6-1.262 1.87-1.408-1.757z",
  fill: "#fff"
}));

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.11ad6938.svg";
export { ForwardRef as ReactComponent };